<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                // console.log("selected ", selectedItem)
                if (this.field.key == 'contactInfo.stateId') {
                    if (
                        selectedItem.dataSegmentId ==
                        process.env.VUE_APP_SSA_ACCOUNT
                    ) {
                        this.$store.commit('updateField', {
                            key: 'asaanAccInfo.region',
                            value: selectedItem.value,
                        })
                    } else {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.region',
                            value: selectedItem.value,
                        })
                    }

                    this.$store.commit('updateField', {
                        key: 'contactInfo.state',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key == 'w9Info.stateId') {
                    this.$store.commit('updateField', {
                        key: 'w9Info.state',
                        value: selectedItem.title,
                    })
                }
            }
        },
    }, // End of Component > watch
}
</script>
